import * as React from "react";

interface Props {}
interface State {}

class PrivacyPolicyPage extends React.Component<Props, State> {
  state = {};

  render() {
    return (
      <div>
        <div style={{ marginTop: 20, padding: 50 }}>
          <h2 style={{ fontWeight: "bold", marginBottom: 20 }}>
            POLÍTICA DE PRIVACIDAD
          </h2>

          <p>
            El presente Política de Privacidad establece los términos en que la
            aplicación móvil “Taxio” , creada y mantenida por Cosmesoft usa y
            protege la información que es proporcionada por sus usuarios al
            momento de utilizar su aplicación. Esta compañía está comprometida
            con la seguridad de los datos de sus usuarios. Cuando le pedimos
            llenar los campos de información personal con la cual usted pueda
            ser identificado, lo hacemos asegurando que sólo se empleará de
            acuerdo con los términos de este documento. Sin embargo esta
            Política de Privacidad puede cambiar con el tiempo o ser actualizada
            por lo que le recomendamos y enfatizamos revisar continuamente esta
            página para asegurarse que está de acuerdo con dichos cambios.
          </p>
          <p>
            <strong>Información que es recogida</strong>
          </p>
          <p>
            Nuestra aplicación podrá recoger información personal por ejemplo:
            Nombre,&nbsp; información de contacto como&nbsp; su dirección de
            correo electrónico e información demográfica. Adicionalmente, en
            caso de que autorice expresamente el uso de los sistemas de
            geolocalización de su dispositivo a través de nuestra aplicación, la
            información sobre su localización geográfica (longitud y latitud del
            GPS del dispositivo) durante el uso o ejecución en segundo plano de
            la App, será asociada a un código único que será asignado a su
            dispositivo. Así mismo cuando sea necesario podrá ser requerida
            información específica para procesar algún pedido o realizar una
            entrega o facturación.
          </p>
          <p>
            <strong>Uso de la información recogida</strong>
          </p>
          <p>
            Los datos personales de los usuarios serán utilizados en la
            aplicación de Taxio para un funcionamiento eficiente. Nuestra
            aplicación requiere cierta información de carácter personal,
            incluyendo dirección de e-mail, número de celular, ubicación,
            documento de identidad, entre otros. La recolección de información
            permite ofrecer a los Titulares de los datos funcionalidades que
            satisfagan sus necesidades dentro de la aplicación. La Información
            Personal que se recaba tiene las siguientes finalidades:
          </p>
          <li>
            {" "}
            Recopilamos los datos de su ubicación para ubicar en tiempo y
            espacio al Titular de los datos para poder prestar un servicio
            eficiente y rápido en las entregas.
          </li>
          <li>
            Recopilamos los datos de su contacto para que exista una
            comunicación con el titular de los datos ante cualquier eventualidad
            que surgiera durante la prestación de los servicios de entrega.
          </li>
          <li>
            La información personal sólo podrá ser utilizada en el marco de la
            prestación del servicio de entrega y no será empleada con fines
            publicitarios o promocionales u otras actividades que no estén
            relacionadas con Taxio Driver.
          </li>
          <li>
            Utilizamos tu contacto para enviar información o mensajes por e-mail
            sobre publicidad o promociones, notificaciones, de interés para los
            usuarios.
          </li>
          <br />

          <p>
            {" "}
            <strong>Obligaciones del usuario </strong>
          </p>
          <p>
            <b>Tipo de información: </b>
            El titular de los datos está obligado a proporcionar sus datos e
            informaciones de contactos verdaderos a fin de que haya una
            transparencia al momento de utilizar los servicios de TAXIO.
          </p>

          <p>
            Las informaciones proporcionadas por los Drivers de Taxio deben de
            ser las verdaderas, correspondiente a cada persona legal. Serán
            dadas de baja los nombres de usuarios falsos y/o usuarios que
            proporcionen documentos que no correspondan a dicha persona.
          </p>

          <p>
            <b>Menores de Edad:</b> La Aplicación está dirigida exclusivamente a
            personas mayores de edad con capacidad legal de contratar los
            servicios que brinda Taxio, estando por tanto restringida la entrada
            de menores de 18 (dieciocho) años al mismo. Sin perjuicio de lo
            anterior, Cosmesoft se reserva el derecho de verificar, por los
            medios que considere más oportunos, la edad real de cualquier
            Titular de los datos.
          </p>
          <p>
            En caso de que esto no fuese cumplido como se establece en la
            presente política de privacidad, el usuario será dado de baja
            inmediatamente de la aplicación.
          </p>
          <p>
            <b>Taxio Driver: </b> Una vez el driver haya aceptado una entrega y
            tenga a su cargo el objeto de la entrega, está obligado a realizar
            la entrega a quien corresponda.
          </p>
          <p>
            {" "}
            <strong>Control de su información personal</strong>
          </p>

          <p>
            Una vez registrado en la aplicación esta compañía no venderá, cederá
            ni distribuirá la información personal que es recopilada sin su
            consentimiento, salvo que sea requerido por un juez con un orden
            judicial.
          </p>
          <p>
            Cosmesoft Se reserva el derecho de cambiar los términos de la
            presente Política de Privacidad en cualquier momento.
          </p>
        </div>
      </div>
    );
  }
}

export default PrivacyPolicyPage;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicyPage.tsx